import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { toggle } from '~/core/helpers/animation/animation.helper';
import { generateUid } from '~/core/helpers/uid/uid.helper';

import { CollapseStateEnum } from './enums/collapseState.enum';
import { VtmnPlayIconTypeEnum } from '../vtmn-play-icon/enums/vtmn-play-icon-type.enum';
import { VtmnPlayIconButtonSizeEnum } from '../buttons/vtmn-play-icon-button/enum/vtmn-play-icon-button-size.enum';
import { VtmnPlayIconButtonVariantEnum } from '../buttons/vtmn-play-icon-button/enum/vtmn-play-icon-button-variant.enum';

@Component({
  selector: 'app-collapse',
  templateUrl: './collapse.component.html',
  animations: [toggle()],
  styleUrls: ['./collapse.component.scss'],
})
export class CollapseComponent implements OnInit {
  @Input() public buttonExtraClass?: string;
  @Input() public closedTitle?: string;
  @Input() public disabled: boolean;
  @Input() public iconName: VtmnPlayIconTypeEnum =
    VtmnPlayIconTypeEnum.ChevronDown;
  @Input() public isCart = false;
  @Input() public isCartTaxes = false;
  @Input() public isFooter = false;
  @Input() public isOpen = false;
  @Input() public title: string;

  @Output() public readonly collapseToggle = new EventEmitter<string>();

  public readonly collapseId = generateUid();
  public readonly vtmnPlayIconButtonSize = VtmnPlayIconButtonSizeEnum;
  public readonly vtmnPlayIconButtonVariant = VtmnPlayIconButtonVariantEnum;

  public ngOnInit(): void {
    if (!this.closedTitle) {
      this.closedTitle = this.title;
    }
  }

  public get btnText(): string {
    return this.isOpen ? this.title : this.closedTitle;
  }

  public get contentId(): string {
    return `content-${this.collapseId}`;
  }

  public toggle(): void {
    this.isOpen = !this.isOpen;

    this.collapseToggle.emit(
      this.isOpen ? CollapseStateEnum.Expended : CollapseStateEnum.Collapsed
    );
  }
}
